import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  Input,
  OnInit,
  Output,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { HeaderService } from '@shared/services';
import { InvestmentJurisdictionQuery } from '@shared/typings/investment-juridisction-query.type';
import { cloneDeep } from 'lodash-es';
import { InvestmentJurisdictionShort } from 'src/app/modules/admin/models/investment-jurisdiction-short';
import { InvestmentJurisdictionService } from 'src/app/modules/admin/services';
import { ComboboxComponent } from '../combobox/combobox.component';

@Component({
  standalone: false,
  selector: 'gstar-investment-jurisdiction-combobox',
  templateUrl: './investment-jurisdiction-combobox.component.html',
  styleUrls: ['./investment-jurisdiction-combobox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvestmentJurisdictionComboboxComponent implements OnInit {
  hasInitialValue = input<boolean>(false);
  isEntityTypeSection = input<boolean>(false);
  useCountryMaterialFilter = input<boolean>(true);
  onlyActives = input<boolean>(false);
  filterQuery = input<InvestmentJurisdictionQuery>();

  private readonly investmentJurisdictionService = inject(
    InvestmentJurisdictionService
  );
  private readonly headerService = inject(HeaderService);

  invJurisdictions: WritableSignal<InvestmentJurisdictionShort[]> = signal<
    InvestmentJurisdictionShort[]
  >([]);

  @Input() value!: InvestmentJurisdictionShort | null | undefined;
  @Input() disabled?: boolean;
  @Input() required?: boolean;

  @Output() selectInvestmentJurisdiction: EventEmitter<
    InvestmentJurisdictionShort | null | undefined
  > = new EventEmitter();
  @Output() clearInvestmentJurisdiction: EventEmitter<void> =
    new EventEmitter();

  @ViewChild('comboBox')
  comboBoxComp!: ComboboxComponent<InvestmentJurisdictionShort>;

  ngOnInit(): void {
    this.headerService.selectedClient$.subscribe(() => {
      if (!this.hasInitialValue()) {
        this.invJurisdictions.set([]);
        this.selectInvestmentJurisdictionHandler(undefined);
      }
      this.loadInvestmentJurisdiction();
    });
    this.loadInvestmentJurisdiction();
  }

  loadInvestmentJurisdiction(): void {
    const applyActiveFilter = (
      items: InvestmentJurisdictionShort[]
    ): InvestmentJurisdictionShort[] => {
      if (!this.onlyActives()) {
        return items;
      }

      return items.filter(item => item.isActive);
    };

    if (this.isEntityTypeSection()) {
      this.investmentJurisdictionService
        .getAllInvestmentJurisdiction()
        .subscribe(response => {
          this.invJurisdictions.set(
            applyActiveFilter(cloneDeep(response.items))
          );
        });
    } else if (this.useCountryMaterialFilter()) {
      this.investmentJurisdictionService
        .activeInvestmentJurisdictionList()
        .subscribe(response => {
          this.invJurisdictions.set(
            applyActiveFilter(cloneDeep(response.items))
          );
        });
    } else if (this.filterQuery()) {
      this.investmentJurisdictionService
        .getAllInvestmentJurisdiction(this.filterQuery())
        .subscribe(response => {
          this.invJurisdictions.set(
            applyActiveFilter(cloneDeep(response.items))
          );
        });
    } else {
      this.investmentJurisdictionService
        .getAllInvestmentJurisdiction()
        .subscribe(response => {
          this.invJurisdictions.set(
            applyActiveFilter(cloneDeep(response.items))
          );
        });
    }
  }

  selectInvestmentJurisdictionHandler(
    investmentJurisdiction?: InvestmentJurisdictionShort | null | undefined
  ): void {
    this.value = investmentJurisdiction;
    this.selectInvestmentJurisdiction.emit(investmentJurisdiction);
  }

  clearInvestmentJurisdictionHandler(): void {
    this.value = null;
    this.selectInvestmentJurisdictionHandler();
    this.clearInvestmentJurisdiction.emit();
  }
}
